import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import clubStore from '../../../storage/ClubStore'
import TrainingsList from '../TrainingsList'
import {useLocation} from "react-router-dom";
import appStore from '../../../storage/AppStore'
import Select from '../../../ui/Select'
import Btn from '../../../ui/Btn'
import PageLayout from '../../PageLayout'

const Trainings = () => {
  const location = useLocation();
  const team = clubStore.trainer.team;
  useEffect(() => {
    clubStore.getTeamsTrainer().then(() => {
      if (clubStore.teams.length > 0) {
        if (!clubStore.trainer.team_id) {
          clubStore.trainer.setProperty('team_id', clubStore.teams[0].id)
        }
        clubStore.trainer.getClasses();
      }
    })
  }, [location.pathname]);
  return (
    <PageLayout header={
        <div className="flex align-items-center justify-content-between">
          <h3 className="m-0">{team.team_name}</h3>
          <span className="text-500 text-sm">
            {appStore.tr.trainings}: {team.classes?.length || 0}
          </span>
        </div>
      }
      filters={
        <div className="col-12 flex justify-content-start align-items-center mb-2">
          <div className="mr-2">
            <Select
              store={clubStore.trainer}
              prop={'team_id'}
              label={appStore.tr.team}
              options={clubStore.teams}
              for_search={true}
            />
          </div>
          <div>
            <Btn
              className={"btn btn-primary"}
              onClick={() => {
                clubStore.trainer.getClasses()
              }}
            ><i className="ci ci-search"/> &nbsp;{appStore.tr.search}</Btn>
          </div>
        </div>
      }>
      <TrainingsList role={"TRN"} team={team}/>
    </PageLayout>
  );
}
export default observer(Trainings);